import { getToken } from '../../utils/auth';
import apiFetch from '../core/apiFetch';
import { checkStatus, handleError } from '../../utils/api';
import { mapEligibilityCheck } from '../register/helpers';
import { EligibilityCheckResponse } from '../../interfaces/register';

interface EligibilityCheck {
  eligibilityCheck: EligibilityCheckResponse | undefined;
}

const getEligibilityCheckAsync = async (
  id: string,
  token?: string
): Promise<EligibilityCheck> => {
  const url = `api/v1/eligibility_checks/${id}`;

  try {
    const jwt = token || getToken();
    const response = await apiFetch(jwt, url, {
      method: 'GET',
    });

    await checkStatus(response);

    const { eligibility_check: eligibilityCheck } = await response.json();

    return { eligibilityCheck: mapEligibilityCheck(eligibilityCheck) };
  } catch (error) {
    handleError('unexpected status - get eligibility check', error);
    return { eligibilityCheck: undefined };
  }
};

export default getEligibilityCheckAsync;
